import { render } from "./Pago.vue?vue&type=template&id=38b934ae&scoped=true"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"

import "./Pago.vue?vue&type=style&index=0&id=38b934ae&scoped=true&lang=css"

import exportComponent from "/var/www/html/facturacion/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38b934ae"]])

export default __exports__